import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { useState } from "react";
import { useMedia, useVideo, useVideos } from "../../hooks";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { Video } from "../../data-parsing/videos/Video";
import {
  CreationForm,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import { AddVideoFormTemplate } from "../../data-parsing/videos/FormTemplate";
import DataTable from "../../components/dataTables/DataTable";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import DragDropInput from "../../components/form/DragDropInput";
import { fileToDataURL } from "../../data-parsing/parseUtils";

export function Videos() {
  const [query, setQuery] = useState(null);
  const { videos, createVideo, deleteVideo } = useVideos(query);
  const { updateVideo } = useVideo();
  const { createMedia } = useMedia("food/videos/", "");
  const colDefs = buildColDefs(Video);



  

  const afterSubmit = (newElement, parsedFormData) => {
    fileToDataURL(
      newElement?._id,
      parsedFormData[0][`video`],
      "",
      createMedia,
      false,
      "Video"
    );
    if (parsedFormData[0][`thumbnail`] && parsedFormData[0][`thumbnail`].size) {
      fileToDataURL(
        /*         newElement?._id + "/img", */
        newElement?._id,
        parsedFormData[0][`thumbnail`],
        "",
        createMedia,
        true
      );
    }
  };

  return (
    <LeftSideMenu active="videos">
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-t-0 m-b-30 pull-right">VIDEOS</h4>
                <TabbedContent
                  tabHeaders={[
                    <button data-toggle="tab" aria-expanded="true">
                      <i className="fas fa-plus-circle"></i> NUEVO VIDEO
                    </button>,
                    <button
                      data-toggle="tab"
                      aria-expanded="false"
                      onClick={() => setQuery(0)}
                    >
                      <i className="far fa-eye"></i> LISTAR VIDEOS
                    </button>,
                  ]}
                >
                  <div className="fade in ">
                    {JSON.stringify(videos)}
                    <div className="row">
                      <CreationForm
                        createFunction={createVideo}
                        afterSubmit={afterSubmit}
                      >
                        <div className="col-md-5">
                          <div className="form-group">
                            <label>Imagen</label>
                            <DragDropInput
                              fileTypes={["JPG", "PNG", "GIF"]}
                              name={"thumbnail"}
                              style={{ height: "300px" }}
                            />
                          </div>

                          <div className="form-group">
                            <label>Video</label>
                            <DragDropInput
                              fileTypes={["MP4", "WEBM"]}
                              name={"video"}
                              style={{ height: "300px" }} /*required={true}*/
                            />
                          </div>
                        </div>
                        <CreationFormTemplate
                          formTemplate={AddVideoFormTemplate}
                          dataTemplate={Video}
                        />

                        <div className="col-sm-12">
                          <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                            <i className="far fa-save"></i> Guardar Vídeo
                          </button>
                        </div>
                      </CreationForm>
                    </div>
                  </div>

                  <div className="fade in">
                    <DataTable
                      data={videos}
                      colDefs={colDefs}
                      dataId={"Videos"}
                      scrollX={false}
                      allowHiddenColumns={true}
                      dataTemplate={Video}
                      resizable={true}
                      className="table table-bordered panel-group"
                      editElement={updateVideo}
                      deleteElement={deleteVideo}
                    />
                  </div>
                </TabbedContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
